import { useState } from 'react';
import { Check, Copy, Download } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface Props {
  codes: string[];
  /** Optional: shown in copy-button success state + clipboard label. */
  label?: string;
}

export function BackupCodesView({ codes, label = 'News1Live CMS — 2FA backup codes' }: Props) {
  const [copied, setCopied] = useState(false);

  const payload = codes.join('\n');

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(payload);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard API can fail in non-secure contexts (http://) — fall back
      // is the download button.
    }
  };

  const handleDownload = () => {
    const blob = new Blob([`${label}\n\n${payload}\n`], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'news-cms-2fa-backup-codes.txt';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 gap-2 rounded-md border border-amber-200 bg-amber-50 p-3 font-mono text-sm dark:border-amber-900/40 dark:bg-amber-900/10">
        {codes.map((c) => (
          <div key={c} className="text-center text-amber-900 dark:text-amber-200">
            {c}
          </div>
        ))}
      </div>
      <div className="flex gap-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => {
            void handleCopy();
          }}
        >
          {copied ? (
            <>
              <Check className="mr-1.5 h-3.5 w-3.5" /> คัดลอกแล้ว
            </>
          ) : (
            <>
              <Copy className="mr-1.5 h-3.5 w-3.5" /> คัดลอก
            </>
          )}
        </Button>
        <Button type="button" variant="outline" size="sm" onClick={handleDownload}>
          <Download className="mr-1.5 h-3.5 w-3.5" /> ดาวน์โหลด .txt
        </Button>
      </div>
      <p className="text-xs text-amber-700 dark:text-amber-300">
        เก็บรหัสเหล่านี้ในที่ปลอดภัย — แต่ละรหัสใช้ได้ครั้งเดียว และจะไม่แสดงอีก
      </p>
    </div>
  );
}
